import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pv-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss'],
    standalone: false
})
export class ActionButtonComponent {
  @Input() label?: string;
  @Input() icon?: string;
  @Input() disabled: boolean = false;
  @Input() size: 'tiny' | 'small' | 'medium' | 'large' | 'giant' = 'small';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() loading: boolean = false;
  
  @Output() buttonClick = new EventEmitter<Event>();

  get hasIcon(): boolean {
    return !!this.icon;
  }

  get hasLabel(): boolean {
    return !!this.label;
  }

  onClick(event: Event): void {    
    if (!this.disabled && !this.loading) {
      event.preventDefault();
      event.stopPropagation();
      this.buttonClick.emit(event);
    }
  }
}
